module.exports = __webpack_public_path__ + "images/places/training_650-a8eb7922538de21e2cb25c72c8adec5b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_650.jpg
 ** module id = 318
 ** module chunks = 0
 **/